// extracted by mini-css-extract-plugin
module.exports = {"WrapperWrapper":"SearchComponent_WrapperWrapper__1SMh7","Wrapper":"SearchComponent_Wrapper__1BXn0","IconsWrapper":"SearchComponent_IconsWrapper__M1r8y"};